const LinkedInIcon = ({ size = 12 }: { size?: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 15 15"
      fill="none"
      style={{ paddingRight: "2px" }}
    >
      <path
        d="M3.38713 4.93259H0.252808V14.9278H3.38713V4.93259Z"
        fill="#0E0E0E"
      />
      <path
        d="M11.8657 4.71591C11.7502 4.70146 11.6274 4.69424 11.5046 4.68702C9.74968 4.6148 8.76028 5.65476 8.41362 6.10252C8.31974 6.22529 8.2764 6.29751 8.2764 6.29751V4.96145H5.2793V14.9566H8.2764H8.41362C8.41362 13.9383 8.41362 12.9273 8.41362 11.909C8.41362 11.3601 8.41362 10.8112 8.41362 10.2624C8.41362 9.5835 8.36307 8.8613 8.7025 8.24022C8.99138 7.72024 9.51135 7.46025 10.0963 7.46025C11.8296 7.46025 11.8657 9.02741 11.8657 9.17185C11.8657 9.17907 11.8657 9.18629 11.8657 9.18629V15H15V8.47854C15 6.24696 13.8662 4.93257 11.8657 4.71591Z"
        fill="#0E0E0E"
      />
      <path
        d="M1.81993 3.63986C2.82505 3.63986 3.63986 2.82505 3.63986 1.81993C3.63986 0.814811 2.82505 0 1.81993 0C0.814807 0 0 0.814811 0 1.81993C0 2.82505 0.814807 3.63986 1.81993 3.63986Z"
        fill="#0E0E0E"
      />
    </svg>
  );
};

export default LinkedInIcon;
